<template>
<router-view />
</template>

<script>
export default {
  name: 'OperationsSiteEnv',
  routeInfo: {
    label: '动环数据',
    icon: 'fa fa-users'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/08Operations/07Site-Env/index.vue